export default __webpack_public_path__ + "static/BME280-3bde3a25ec0d29d8b8674df1ebd78895.png";